import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-44d57e84")
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col-6" }
const _hoisted_3 = { class: "p-input-icon-left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_5 = { class: "p-col-6 p-text-right" }
const _hoisted_6 = { class: "p-col-12 " }
const _hoisted_7 = { class: "p-col-12" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModuleHeader = _resolveComponent("ModuleHeader")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_VideosTable = _resolveComponent("VideosTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ModuleHeader, {
      title: "CoderPlus",
      showGoBack: false
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_InputText, {
            disabled: _ctx.loading,
            placeholder: "Buscar"
          }, null, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Button, {
            label: "Ingresar nuevo",
            class: "p-button-rounded",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({
                    name: _ctx.CoderPlusNames.CREATE
                })))
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_VideosTable)
      ])
    ])
  ], 64))
}